export default "/images/65f7c73bb8eb3e120e04387a66e0ea23.jpg";